import styled, { css } from "styled-components";

const ItemWrapper = styled.div`
	display: flex;
	padding: 5px 0px;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	align-self: stretch;
	border-radius: 15px;
	background: var(--input-bg-has-value);
	width: 100%;
`;

const ItemTitle = styled.div`
	border-radius: 15px 15px 0px 0px;
	color: #f7f7fc;
	font-size: 10px;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.3px;
	display: flex;
	padding: 5px 10px;
	justify-content: center;
	align-items: center;
	align-self: stretch;
	background: var(--main-explosive-gradient-020);

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 14px;
	}
`;

const ItemImg = styled.img`
	width: auto;
	height: 80px;
	border-radius: 20px;
`;

const ItemContentWrapper = styled.div`
	display: flex;
	padding: 5px 10px;
	align-items: center;
	gap: 15px;
	flex: 1 0 0;
	width: 100%;
	background: var(--main-explosive-gradient-020);
`;

const ContentTitle = styled.div`
	display: flex;
	align-items: center;
	color: #f7f7fc;
	letter-spacing: 0.3px;
	line-height: 20px;
	gap: 3px;

	span {
		display: flex;
		&:first-of-type {
			font-size: 14px;
			font-weight: 700;
		}

		&:last-of-type {
			font-size: 12px;
			font-weight: 600;
		}
	}
`;

const ContentButton = styled.div`
	color: #fff;
	text-align: center;
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
	display: flex;
	height: 30px;
	padding: 0 15px 0 10px;
	justify-content: center;
	align-items: center;
	gap: 5px;
	border-radius: 20px;
	background: linear-gradient(180deg, var(--main-color-light) 0%, var(--main-color-dark) 100%);

	${({ isCompletedPage }) =>
		isCompletedPage &&
		css`
			opacity: 0.5;
			pointer-events: none;
		`}
`;

const ItemContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 5px;
`;

const DetailsButton = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
	border-top: 1px solid var(--main-explosive-light);
	padding-top: 5px;
	svg {
		width: 14px;
		height: 14px;
		path {
			stroke: var(--main-explosive-light);
		}
	}

	${({ rotate }) =>
		rotate &&
		css`
			svg {
				transform: rotate(180deg);
				animation: rotate 0.1s;
			}
		`}
`;

const ButtonText = styled.div`
	display: flex;
	color: var(--main-explosive-light);
	text-align: center;
	font-size: 10px;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.3px;
	min-width: 42px;
	justify-content: flex-end;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const DateWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	padding: 10px;
	justify-content: center;
	align-self: stretch;
`;

const Date = styled.div`
	align-items: center;
	display: flex;
	flex: 1 0 0;
	color: #a0a3bd;
	text-align: center;
	font-size: 10px;
	font-weight: 600;
	line-height: 12px;
	letter-spacing: 0.3px;
	justify-content: center;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

export {
	ButtonText,
	ContentButton,
	ContentTitle,
	Date,
	DateWrapper,
	DetailsButton,
	ItemContent,
	ItemContentWrapper,
	ItemImg,
	ItemTitle,
	ItemWrapper,
};
